import { JSX } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function LastSSNInput({ value, onChange }: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
        onChange(digits);
      }}
      inputProps={{
        inputMode: 'numeric',
        maxLength: 4,
        'data-testid': 'last-ssn-input',
      }}
      placeholder="Last 4 digits"
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
